import React, { useEffect, useState } from 'react';
import { getBulkPricingItems } from '../../api/bulkPricingApi';
import { PendingItem } from '../bulkPricing/BulkPricingPendingSection';
import VarietyEditorDialog from '../varietyPricing/VarietyEditorDialog';

// Mount a fresh dialog for each branch/format. Each operation contains at most
// one item for that exact format, enforced by the operation item's unique index.
export default function PriceListPendingChangesDialog({ target, onClose, onResolved, disabled, canUpdateProduct, canUpdatePrice, complexPriceRules, userId }) {
  const { format, operations } = target;
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [version, setVersion] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    Promise.all(operations.map(async (operation) => {
      const response = await getBulkPricingItems(operation.id, 1, format.id);
      return (response.items || []).filter((item) => String(item.varietyPriceId) === String(format.id))
        .map((item) => ({ operation, item }));
    })).then((results) => { if (active) setEntries(results.flat()); })
      .catch(() => { if (active) setError('No se pudieron cargar los cambios de este formato.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [operations, format.id, version]);

  const refresh = () => setVersion((value) => value + 1);
  const resolved = (summary, item) => {
    setEntries((current) => current.filter((entry) => entry.item.id !== item.id));
    onResolved?.(summary, item);
  };
  return <VarietyEditorDialog
    eyebrow="Lista de precios"
    title="Cambios pendientes del formato"
    description="Revisa el cambio solicitado, completa los datos necesarios y aplícalo a este formato."
    onClose={onClose} busy={busy} closeLabel="Cerrar cambios pendientes"
    footerNote="Cada cambio se aplica u omite individualmente."
  >
    <div className="mx-auto max-w-3xl space-y-4">
      {loading ? <p role="status" className="p-4 text-sm text-slate-600">Cargando cambios pendientes…</p>
        : error ? <p role="alert" className="p-4 text-sm text-red-700">{error} <button type="button" className="underline" onClick={refresh}>Reintentar</button></p>
          : entries.length ? entries.map(({ operation, item }) => <div key={item.id}>
            <p className="mb-2 text-xs text-slate-500">Solicitado el {new Date(operation.createdAt).toLocaleString('es-CL')}</p>
            <PendingItem key={`${item.id}:${version}`} operation={operation} item={item}
              onResolved={resolved} onRefresh={refresh} onBusyChange={setBusy}
              disabled={disabled || busy} canUpdateProduct={canUpdateProduct} canUpdatePrice={canUpdatePrice}
              complexPriceRules={complexPriceRules} userId={userId} />
          </div>) : <p role="status" className="p-4 text-sm text-slate-700">Este formato ya no tiene cambios pendientes.</p>}
    </div>
  </VarietyEditorDialog>;
}
